export default __webpack_public_path__ + "static/media/38_desktop.bcc5b178.jpeg";